export const registered = new Set();

export const register = (fn) => {
    if (typeof fn === 'function') {
        registered.add(fn);
    } else {
        console.warn('Attempted to register a non-function callback:', fn);
    }
};

export const unregister = (fn) => {
    if (registered.has(fn)) {
        registered.delete(fn);
    } else {
        console.warn('Attempted to unregister a non-existent callback:', fn);
    }
};

const loggerMiddleware = (store) => (next) => (action) => {
    for (const cb of registered) {
        try {
            cb(action);
        } catch (error) {
            console.error('Error in registered callback:', error);
        }
    }
    return next(action);
};

export default loggerMiddleware;
